import { useState } from 'react';
import { useLocation } from 'react-router';

import { AnalyticsEventName } from '@/shared/config';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { trackEvent } from '@/shared/lib';

import { conditionModel } from '@/entities/condition';
import { reportsModel, useCheckReportSignature } from '@/entities/reports';
import { toothModel } from '@/entities/tooth';

export const useApproveTooth = (
  toothID: string,
  isApproved: boolean,
  isToothCard?: boolean,
) => {
  const [isApproveToothLoading, setApproveToothLoading] = useState(false);

  const location = useLocation();

  const { checkReportSignature } = useCheckReportSignature();

  const ISONumber = useAppSelector(
    toothModel.selectors.selectISONumberByID(toothID),
  );

  const yellowConditionsIDs = useAppSelector(
    conditionModel.selectors.selectYellowIDsByToothID(toothID),
  );

  const dispatch = useAppDispatch();

  const toggleApproveTooth = () => {
    checkReportSignature({
      onSignatureChecked: async () => {
        setApproveToothLoading(true);

        try {
          if (!isApproved) {
            await dispatch(
              reportsModel.thunks.setReportToothApproved({
                ToothID: toothID,
                ToothConditionIDs: yellowConditionsIDs,
              }),
            );
          } else {
            await dispatch(
              reportsModel.thunks.setReportToothDisapproved({
                ToothID: toothID,
              }),
            );
          }
        } finally {
          if (!isApproved) {
            const isToothPage = location.pathname.includes('/tooth/');

            const getEventName = (): AnalyticsEventName => {
              if (isToothPage && !isToothCard) {
                return 'ToothPageMainApproveButtonClicked';
              }

              if (isToothPage && isToothCard) {
                return 'ToothPageToothCardApproveButtonClicked';
              }

              return 'ReportPageToothApproveButtonClicked';
            };

            trackEvent({
              eventName: getEventName(),
              properties: {
                tooth_number: ISONumber,
              },
            });
          }

          setApproveToothLoading(false);
        }
      },
    });
  };

  return { toggleApproveTooth, isApproveToothLoading };
};
